<template>
  <div v-wechat-title="$route.meta.title" class="indexPage">
    <div class="container">
      <div class="vin-main">
        <div class="fixed-top">
          <img src="../assets/img/jqr.png" >
          <div>
            <span>请输入vin码或者上传vin码图片</span>
          </div>
          <div @click="goBack" class="goodsSearchBtn">商品查询</div>
        </div>
        <ul :class="showPop?'h50':''" ref="listBox">
          <div v-for="(item, index) of vinMsgList" :key="index">
            <li class="left" v-if="item.msgType==2" @click="toIndexPage(item)">
              <i class="face"></i>
              <div>
                <h1>汽配通Data机器人</h1>
                <div class="info">
                  <span class="info-title"><i></i>小程序</span>
                  <span>汽配通智能报价</span>
                  <img src="../assets/img/cover.png" class="cover-img">
                </div>
              </div>
            </li>
            <li class="left" v-else-if="item.msgType==3">
              <i class="face"></i>
              <div>
                <h1>报价机器人</h1>
                <div class="info errMsg">
                  <span>{{item.errMsg}}</span>
                </div>
              </div>
            </li>
            <li class="left" v-else-if="item.msgType==4" @click="toDinghuoMini">
              <i class="face"></i>
              <div>
                <h1>汽配通Data机器人</h1>
                <div class="info">
                  <span class="info-title"><i></i>小程序</span>
                  <span>汽配通智能报价</span>
                  <img src="../assets/img/dinghuo.png" class="cover-img">
                </div>
              </div>
            </li>
            <li class="right" v-else>
              <div class="info">
                <span v-if="item.imgUrl"><img :src="item.imgUrl" class="imgUrl"></span>
                <span v-else>{{item.vinCode}}</span>
              </div>
              <i class="face author"></i>
            </li>
          </div>
        </ul>
      </div>
      <div class="footer-bar">
        <div class="input-con">
          <input type="search" value="" class="sarchInput" v-model="vinCode">
          <div class="send-btn" @click="sendMsg">发送</div>
          <div class="add-btn" @click="showPop = !showPop">+</div>
        </div>
        <div class="camera" v-show="showPop">
          <div>
            <img src="../assets/img/photo.png">
            <span>相册</span>
            <input
                ref="pictureC_file1"
                class="pictureC_file"
                @change="upload('pictureC_file1','img1')"
                type="file"
                name="pictureA_file"
              >
          </div>
          <div>
            <img src="../assets/img/camera.png">
            <span>拍摄</span>
            <input
                ref="pictureB_file1"
                capture="camera"
                class="pictureB_file"
                accept="image/*"
                type="file"
                name="pictureA_file"
                @change="upload('pictureB_file1','img1')"
              >
          </div>
        </div>
      </div>
      
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "../styles/activityBills.scss";
.vin-main{
  font-size: 12px;
  position: fixed;
  width: 100%;
  height: calc(100% - 40px);
  .fixed-top{
    display: flex;
    background: #fff;
    padding:5px;
    box-sizing: border-box;
    width: 100%;
    height: 40px;
    div{
      display: flex;
      align-items: center;
    }
    img{
      width: 30px;
      height: 30px;
      border-radius: 30px;
      margin-right: 5px;
    }
    span{
      display: block;
      color: #333;
      &.quick-link{
        color: #4FAE54
      }
    }
    .goodsSearchBtn{
      position: absolute;
      height: 30px;
      line-height: 30px;
      right: 10px;
      color: #4fae54;
    }
  }
  ul{
    padding:10px 5px;
    box-sizing: border-box;
    height: calc(100vh - 80px);
    overflow-y: auto;
    overflow-x: hidden;
    &.h50{
      height: calc(100vh - 120px);
    }
    li{
      display: flex;
      margin-bottom: 10px;
      .face{
        width: 30px;
        height: 30px;
        border-radius: 30px;
        margin-right: 5px;
        background: url(../assets/img/jqr.png) no-repeat;
        background-size:100% 100%; 
        &.author{
          background: url(../assets/img/face.png) no-repeat;
          background-size:100% 100%;
          margin-left:5px;
        }
      }
      h1{
        font-size: 10px;
        font-weight: normal;
        color: #c1c1c1;
        margin-bottom: 5px;
      }
      &.right{
        align-items: center;
        justify-content: flex-end;
      }
      
      .info{
        background: #fff;
        padding:10px;
        color: #333;
        border-radius: 3px;
        span{
          display: block;
          &.info-title{
            display: flex;
            align-items: center;
            font-size: 10px;
            color: #999;
            margin-bottom:5px;
            i{
              background:#f1f1f1 url(../assets/img/link.png) no-repeat center center;
              background-size:auto 70%;
              margin-right:5px;
              display: block;
              width: 18px;
              height:18px;
              border-radius: 18px;
            }
          }
          .imgUrl{
            max-width: 100px;
            max-height: 100px
          }
        }
        .cover-img{
          width: 194px;
          height: 157px;
          margin:5px 0 0 0;
          vertical-align:top;
        }
      }
      
    }
  }
}
.footer-bar{
  position: fixed;
  width: 100%;
  background: #f1f1f1;
  bottom: 0;
  left:0;
  border-top: 1px solid #e6e6e6;
  font-size: 12px;
  .input-con{
    display: flex;
    height: 40px;
    padding:5px;
    box-sizing: border-box;
    align-items: center;
    .sarchInput{
      height: 29px;
      border:none;
      border-radius: 3px;
      padding:0 5px;
      box-sizing: border-box;
      width: calc(100% - 85px);
    }
    .send-btn{
      background: #4FAE54;
      width: 40px;
      height: 29px;
      line-height: 29px;
      color: #fff;
      text-align: center;
      border-radius: 3px;
      margin:0 10px;
    }
    .add-btn{
      width: 23px;
      height: 23px;
      line-height: 23px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #000;
      box-sizing: border-box;
      border-radius: 23px;
      font-size: 22px;
      font-weight: normal;
    }
  }
  .camera{
    display: flex;
    div{
      background: #fff;
      border-radius: 3px;
      padding: 5px 15px;
      margin:0 5px;
      position: relative;
      input{
        position: absolute;
        width: 100%;
        height: 100%;
        left:0;
        top:0;
        opacity: 0;
      }
    }
    img{
      width: 30px;
      height: 25px;
    }
    span{
      display: block;
      text-align: center;
    }
  }
}
</style>
<script>
import Vue from "vue";
import { List, Toast } from "vant";
import util from "../utils/util";
import basedata from "../utils/basedata";
import api from "../services/api";
import car from "../services/car";
import $ from "../utils/axiosp";
import { connect } from "tls";
import buyCarStore from "../store/buycar";
import IndexStore from "../store/Index";
import FirmOrderStore from "../store/FirmOrder";

import {
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Col,
  Row,
  Sticky,
  Search,
  DropdownMenu,
  DropdownItem,
} from "vant";
import Index from "../store/Index";

Vue.use(GoodsAction);
Vue.use(GoodsActionButton);
Vue.use(GoodsActionIcon);
Vue.use(Col);
Vue.use(Row);
Vue.use(List);
Vue.use(Toast);
Vue.use(Sticky);
Vue.use(Search);

export default {
  name: "vinSearch",
  components: {
    
  },
  computed: {
    
  },
  data() {
    return {
      FirmOrderStore,
      IndexStore,
      buyCarObj: buyCarStore,
      buyCarState: buyCarStore.state,
      IndexState: IndexStore.state,
      RobotCode:'',
      showPop:false,
      vinCode:'',
      vinMsgList:[],
      isType: 2
    };
  },
  async created() {
    this.IndexState.toVinSearchPage = false;
  },
  async mounted() {
    this.isType = util.getStoObj("urlQuery").IsTypr;
    this.RobotCode = util.getStoObj("urlQuery").RobotCode
    if(localStorage.getItem('vinMsgList')){
      this.vinMsgList = JSON.parse(localStorage.getItem('vinMsgList'));
    }
    this.scollBottom()
  },
  methods: {
    goBack(){
      this.$router.push("/goodsSearch");
    },
    sendMsg(){
      if(this.vinCode == ''){
        return
      }
      // msgType：1自己发送的vin码消息，2成功获取接口返回的数据，3接口返回的错误消息
      this.vinMsgList.push({
        vinCode:this.vinCode,
        msgType:1
      })
      if(this.vinCode == '1111'){
        this.vinMsgList.push({vinCode:'1111', msgType:4})
        this.scollBottom()
        this.saveVinStorage(this.vinMsgList);
        this.vinCode = '';
      }else{
        this.getVehicleTypeInfoBySJT(this.vinCode)
      }
      
    },
    toDinghuoMini(activeId){
      if(this.isType == 1){
        return Toast('员工身份暂不可进入')
      }
      let DMSCode = util.getStoObj("allinfo").DMSCode;
      let UserId = util.getStoObj("allinfo").UserId;
      let ShopCode = util.getStoObj("allinfo").ShopCode;
      let mobile = util.getStoObj("allinfo").LegalPersonPhone;
      let token = util.getStoObj("urlQuery").QPT_UserToken;
      let OrgText = util.getStoObj("allinfo").OrgText;
      let Eshop_Name = util.getStoObj("allinfo").UserName;
      let timeDiff = new Date().getTime();
      location.href=`${basedata.dinghuoUrl}/#/?Eshop_DMSCode=${DMSCode}&Eshop_ShopCode=${ShopCode}&tab=2&isApp=0&UserType=0&Eshop_Name=${Eshop_Name}&Eshop_Company=${OrgText}&Eshop_Mobile=${mobile}&Eshop_UserToken=${token}&PlatformType=13&isfrom=jiqiren&time=${timeDiff}`
      
    },
    saveVinStorage(vinMsgList){
      if(vinMsgList.length > 20){
        vinMsgList = vinMsgList.filter((item,index)=>{
          return index > (vinMsgList.length - 21)
        })
      }
      localStorage.setItem('vinMsgList', JSON.stringify(vinMsgList));
    },
    toIndexPage(item){
      let urlQuery = util.getStoObj("urlQuery");
      // urlQuery.QPT_UserInfo = JSON.stringify(urlQuery.QPT_UserInfo);
      urlQuery.VehicleTypeId = item.VehicleTypeId;
      urlQuery.Vin = item.vinCode;
      urlQuery.carTypeName = item.carTypeName;
      urlQuery.Keyword = item.vinCode;
      urlQuery.BrandId = '';
      urlQuery.ProductClassifyId = '';
      console.log(urlQuery);
      IndexStore.state.brandList = [];
      IndexStore.state.categoryList = [];
      this.$router.push({
        path:'/',  
        query:urlQuery
      })
    },
    scollBottom(){
      let _listBox = this.$refs.listBox;
      setTimeout(()=>{
        _listBox.scrollTop = _listBox.scrollHeight;
      },100)
    },
    async getVehicleTypeInfoBySJT(vinCode){
      await api.GetVehicleTypeInfoBySJT(vinCode).then((data) => {
				if(data.ResultType === 1 && data.Data){
          let _data = data.Data;
          this.vinMsgList.push({
            vinCode:vinCode,
            msgType:2,
            VehicleTypeId: _data.VehicleTypeId,
            carTypeName: _data.ManufactorName + _data.BrandName + _data.VehicleTypeName + _data.VehicleTypeTitle
          })
        }else{
          this.vinMsgList.push({errMsg:data.Reason, msgType:3})
        }
			},(result)=>{
        let err = result;
        console.log(typeof(result));
        if(typeof(result) == 'object'){
          err = '系统繁忙，请稍后再试'
        }
        this.vinMsgList.push({errMsg:err,msgType:3})
      })
      this.saveVinStorage(this.vinMsgList);
      this.vinCode = '';
      this.scollBottom()
    },
    // 上传图片
    upload(c, d, f) {
      "use strict";
      var that = this;

      var $c = that.$refs[c],
        $d = that.$refs[d],
        file = $c.files[0],
        reader = new FileReader(),
        image = new Image(),
        canvas = that.createCanvas(),
        ctx = canvas.getContext("2d");
      if (file.type.includes("video")) {
        Toast("请上传图片格式的文件");
        return;
      }

      reader.onloadend = function() {
        var result = this.result;
        image.onload = function() {
          // 图片加载完处理
          var imgScale = that.imgScaleW(500, this.width, this.height);
          canvas.width = imgScale.width;
          canvas.height = imgScale.height;
          ctx.drawImage(image, 0, 0, imgScale.width, imgScale.height);
          var dataURL = canvas.toDataURL("image/jpeg"); // 图片base64
          ctx.clearRect(0, 0, imgScale.width, imgScale.height); // 清除画布
          console.log(dataURL.length / 1024);
          if (dataURL.length / 1024 > 1024 * 5) {
            Toast("上传图片不能超过5M");
            return;
          }
          that.vinMsgList.push({vinCode:0, msgType:1, imgUrl:dataURL })
          that.scollBottom()
          $.getVinCode("OCR/VIN", {
            AUTH_AUTO_TOKEN: "ftservice_s20200518174201",
            ImageBase64: dataURL.replace("data:image/jpeg;base64,", ""),
          }).then((res) => {
            if (res.data && res.code == 1) {
              that.getVehicleTypeInfoBySJT(res.data)
            } else {
              that.vinMsgList.push({errMsg:res.msg,msgType:3})
              that.scollBottom()
              this.saveVinStorage(that.vinMsgList);
            }
            
          });

        };
        image.src = result;
        
      };
      reader.readAsDataURL(file);
      this.showPop = false;
    },
    /**
     *  创建画布
     * @returns
     */
    createCanvas() {
      var canvas = document.getElementById("canvas");
      if (!canvas) {
        var canvasTag = document.createElement("canvas");
        canvasTag.setAttribute("id", "canvas");
        canvasTag.setAttribute("style", "display:none;"); //隐藏画布
        document.body.appendChild(canvasTag);
        canvas = document.getElementById("canvas");
      }
      return canvas;
    },
    /**
     * 图片压缩
     * @param maxWidth 最大宽度或最大高度
     */
    imgScaleW(maxWidth, width, height) {
      var imgScale = {};
      var w = 0;
      var h = 0;
      if (width <= maxWidth && height <= maxWidth) {
        // 如果图片宽高都小于限制的最大值,不用缩放
        imgScale = {
          width: width,
          height: height,
        };
      } else {
        if (width >= height) {
          // 如果图片宽大于高
          w = maxWidth;
          h = Math.ceil((maxWidth * height) / width);
        } else {
          // 如果图片高大于宽
          h = maxWidth;
          w = Math.ceil((maxWidth * width) / height);
        }
        imgScale = {
          width: w,
          height: h,
        };
      }
      return imgScale;
    }
  },
};
</script>


